import React, { PropTypes } from 'react';

const Alert = ({children, label, type}) => (
  <div className={`alert alert-${type}`}>
    {label && <strong>{label}</strong>} {children}
  </div>
);


Alert.propTypes = {
  children: PropTypes.any.isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
};

Alert.defaultProps = {
  type: 'danger',
  label: 'Kļūda!'
}


export default Alert;




// WEBPACK FOOTER //
// ./src/components/Form/Alert.js